export function getRecordComment(record: any): string {
    if (!record || typeof record.commentRecord !== 'string') {
        return '';
    }

    return record.commentRecord.trim();
}
